/**
 * Blocks Visibility Module
 *
 * Gestisce la logica di visibilità dei blocchi della sidebar
 */

export {
  should_show_booker_block,
  should_show_discount_codes_block,
  should_show_bill_to_pax_block,
  should_show_stripe_block,
  should_show_otp_block,
  get_blocks_configuration
} from './blocks-visibility-manager'